import CryptoJS from "crypto-js";

/* TODO?: create our own crypto-wrapper module? */

export type ChecksumMD5 = string;

export const getChecksum = (s: string) => {
  return CryptoJS.MD5(s).toString();
};
